// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ViewGrouping(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ViewGrouping" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M4 20H20V17.5H4V20ZM20 8.5H4V15.5H20V8.5ZM4 4V6.5H20V4H4Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ViewGrouping.js.map